// src/features/tower/storeReadiness/time.ts

export function todaySAST(): string {

  const nowSast = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Africa/Johannesburg" })
  );
  const y = nowSast.getFullYear();
  const m = String(nowSast.getMonth() + 1).padStart(2, "0");
  const d = String(nowSast.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function formatDisplayDate(dateStr: string): string {
  const [y, m, d] = dateStr.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  return dt.toLocaleDateString("en-ZA", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
}
